import { FC } from 'react';
import 'twin.macro';
import 'styled-components/macro';

interface AverageRatingProps {
  rating: number;
  votes?: number;
  onClick: () => void;
}

export const AverageRating: FC<AverageRatingProps> = ({ rating, votes = 0, onClick }) => {
  const formattedRating = Number(rating).toLocaleString('en-US', {
    minimumFractionDigits: 1,
    maximumFractionDigits: 1,
  });

  return (
    <span tw="text-xs cursor-pointer" onClick={onClick}>
      ⭐️ {rating ? formattedRating : 'Be the first'} {!!votes && `(${votes})`}
    </span>
  );
};
